import { render, staticRenderFns } from "./FormPaymentHistoryDialog.vue?vue&type=template&id=ecc618a2&"
import script from "./FormPaymentHistoryDialog.vue?vue&type=script&lang=ts&"
export * from "./FormPaymentHistoryDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports